/**
 * @file
 * Behaviours for the anonymous /welcome page.
 */

/**
 * Feeds the pointer position to each B2 service card, where _welcome.scss
 * draws a spotlight at --mx / --my.
 */
Drupal.behaviors.siteWelcomeSpotlight = {
  attach(context) {
    context.querySelectorAll?.('.sw-service:not([data-sw-spotlight])').forEach((card) => {
      card.dataset.swSpotlight = '1';
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--mx', `${event.clientX - rect.left}px`);
        card.style.setProperty('--my', `${event.clientY - rect.top}px`);
      });
    });
  },
};
